import React from 'react';
import PropTypes from 'prop-types';

const IconMapPin = ({ fill, className }) => (
    <svg
        className={`apc-svg-icon ${className}`}
        viewBox="0 0 50 50"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M25.342 22.328a5.046 5.046 0 0 0 5.042-5.053 5.049 5.049 0 0 0-5.042-5.055c-2.78 0-5.039 2.265-5.039 5.055a5.047 5.047 0 0 0 5.04 5.053zm0 3c-4.438 0-8.039-3.607-8.039-8.053 0-4.446 3.6-8.055 8.04-8.055 4.442 0 8.041 3.608 8.041 8.055 0 4.448-3.599 8.053-8.042 8.053zm-3.298 21.24c-3.33-5.39-5.178-8.42-7.17-11.798-.508-.865-.685-1.153-2.014-3.296-1.119-1.805-1.756-2.866-2.395-4.021-1.631-2.95-2.59-5.397-2.885-7.782a20.61 20.61 0 0 1-.08-1.386v-2.033l.008-.158C8.55 6.276 16.395 0 25.342 0c8.954 0 16.804 6.276 17.845 16.094l.009.158v2.033c0 .203-.043 1.017-.084 1.411-.297 2.36-1.256 4.807-2.887 7.757-.637 1.152-1.273 2.21-2.388 4.011-1.33 2.147-1.509 2.438-2.02 3.309-1.944 3.293-3.762 6.276-6.98 11.487l-1.485 2.406-.348.54a2.137 2.137 0 0 1-1.662.794 2.13 2.13 0 0 1-1.674-.819l-.327-.41c-.47-.864-1.3-2.207-1.297-2.203zM25.342 3C17.883 3 11.403 8.165 10.5 16.333v1.952c0 .117.036.812.06 1.04.237 1.908 1.068 4.031 2.53 6.676.609 1.1 1.226 2.127 2.32 3.892 1.345 2.17 1.525 2.462 2.05 3.355 1.977 3.353 3.816 6.369 7.136 11.743l.75 1.214.939-1.52c3.207-5.196 5.018-8.166 6.947-11.434.526-.898.708-1.194 2.055-3.367 1.09-1.76 1.706-2.786 2.313-3.883 1.463-2.646 2.296-4.77 2.532-6.643.026-.26.064-.974.064-1.073v-1.952C39.293 8.165 32.808 3 25.342 3z"
            fill={fill}
        />
    </svg>
);

IconMapPin.propTypes = {
    fill: PropTypes.string,
    className: PropTypes.string,
};

IconMapPin.defaultProps = {
    fill: '#3DCD58',
    className: '',
};

export default IconMapPin;
